import { writable } from "svelte/store"

export enum PriceAlertStatus {
  NotSet = "notSet",
  NeedsVerification = "needsVerification",
  IsSet = "isSet",
}

const initialValue = {
  priceAlert: {
    status: PriceAlertStatus.NotSet,
  },
}

export const reset = () => appStore.set(initialValue)

const appStore = writable(initialValue)

export const setPriceAlertStatus = (status: PriceAlertStatus) => {
  appStore.update((store) => ({
    ...store,
    priceAlert: {
      ...store.priceAlert,
      status,
    },
  }))
}

export default appStore
